import { type WizardValues } from './types'

export const requestWizardSteps = [
  { title: 'Как работаете', description: 'Схемы работы и площадки' },
  { title: 'Откуда забирать', description: 'Города, где лежит товар' },
  { title: 'Куда отгружать', description: 'Склады отгрузки' },
  { title: 'Что за товар', description: 'Категория, габариты, объём и срок' },
  { title: 'Что нужно сделать', description: 'Услуги, упаковка и требования' },
  { title: 'Контакты и файлы', description: 'Как связаться и что приложить' },
] as const

/** На каком шаге находится каждое редактируемое поле заявки. */
const fieldStep: Record<keyof WizardValues, number> = {
  title: 0,
  shipmentTypes: 0,
  marketplaces: 0,
  marketplaceOtherName: 0,
  cities: 1,
  warehouses: 2,
  federalDistricts: 2,
  services: 4,
  subjectId: 3,
  subjectName: 3,
  productUrl: 3,
  productSize: 3,
  packageSize: 3,
  unitCount: 3,
  dueDate: 3,
  description: 4,
  packingType: 4,
  packingComment: 4,
  needsSpecialPacking: 4,
  specialPacking: 4,
  needsTwiceADay: 4,
  requirements: 4,
  phone: 5,
  contacts: 5,
}

const formFields = Object.keys(fieldStep) as (keyof WizardValues)[]

/** Поля шага: по ним мастер проверяет заполнение перед переходом. */
export const fieldsOfStep = (step: number) => formFields.filter((field) => fieldStep[field] === step)

/** Шаг поля; неизвестную серверную ошибку открываем на первом шаге. */
export const stepOfField = (field: string) => fieldStep[field as keyof WizardValues] ?? 0
